module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("合箱编码：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入合箱编号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.inputC()
      }
    },
    model: {
      value: (_vm.boxNumber),
      callback: function($$v) {
        _vm.boxNumber = $$v
      },
      expression: "boxNumber"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近出库订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyList,
      "border": "",
      "stripe": "",
      "row-key": "boxId",
      "max-height": "550px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h4', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库时间",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.createTime ?
          _vm.toDate(scope.row.createTime, "yyyy-MM-dd hh:mm") :
          "时间未知") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#008b8b"
    }
  }, [_vm._v("已出库")])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "show-close": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递出库")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合箱编码："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.boxNumber) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.vipCodes) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单数量："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderCount) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货物类型："
    }
  }, [(_vm.orderInfo.goodType == 1) ? _c('span', {
    staticClass: "tag"
  }, [_vm._v(" 海运 ")]) : (_vm.orderInfo.goodType == 2) ? _c('span', {
    staticClass: "tag tag1"
  }, [_vm._v("\n                海运大件\n              ")]) : (_vm.orderInfo.goodType == 3) ? _c('span', {
    staticClass: "tag tag3"
  }, [_vm._v("\n                空运\n              ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.deliveryTitle) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('span', {
    staticClass: "tag tag4"
  }, [_vm._v(" 未入库 ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.createTime) ? _c('span', [_vm._v(_vm._s(_vm.toDate(
    _vm.orderInfo && _vm.orderInfo.createTime,
    "yyyy-MM-dd hh:mm"
  )) + "\n                "), _c('span', {
    staticClass: "tag tag2"
  }, [_vm._v(" 合箱 ")])]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货柜号：",
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站出库可不填）")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                      ")]
      }
    }], null, false, 1453014801)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.realName) + "\n                      ")]
      }
    }], null, false, 3257019584)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.vipCode) + "\n                      ")]
      }
    }], null, false, 1338675743)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键出库，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("出库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合箱出库",
      "visible": _vm.isExistMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "left",
      "destroy-on-close": _vm.trueMark
    },
    on: {
      "update:visible": function($event) {
        _vm.isExistMark = $event
      },
      "opened": _vm.openFail,
      "closed": _vm.closed
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n      出库失败，系统无匹配运单。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "audioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isRepeatMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.reHandleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.isRepeatMark = $event
      },
      "opened": _vm.openRepeat
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("\n      合箱出库  (" + _vm._s(_vm.orderNum) + ")\n    ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("重复出库，本箱已被出库")]), _vm._v(" "), _c('div', {
    staticClass: "repeAudioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isPassMark,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.succHandleClose,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isPassMark = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('audio', {
    attrs: {
      "src": "../../../static/audio/chukuSuccess.mp3",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d9cf90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/distribution/outStorage.vue
// module id = 1243
// module chunks = 2